import React from 'react';
import { IconFileDescription, IconDeviceMobileCheck, IconTrophy } from '@tabler/icons-react';
import { Col, Row } from 'reactstrap';
import moment from 'moment';

import { usePhases } from '../../../shared/config';
import styles from './CampaignFlow.module.scss';

const CampaignFlow = () => {
    const phases = usePhases();

    const shortenDate = (from, until) => {
        if (until) {
            return moment(from).format('DD.MM.') + ' - ' + moment(until).format('DD.MM.');
        }
        return moment(from).format('DD.MM.');
    };

    return (
        <Row>
            <Col xs="12" lg="6" className="my-2">
                <Row>
                    <Col xs="4" lg="12" className="d-flex align-items-center mb-2">
                        <IconFileDescription size={48} className="w-100 text-primary" />
                    </Col>
                    <Col xs="7" lg="12" className="d-flex align-items-center">
                        <h3 className={`text-primary text-left text-lg-center m-0 w-100 ${styles.CampaignFlowHeading}`}>
                            Bewerbung:
                            <br />
                            ab sofort
                        </h3>
                    </Col>
                </Row>
            </Col>
            <Col xs="12" lg="6" className="my-2">
                <Row>
                    <Col xs="4" lg="12" className="d-flex align-items-center mb-2">
                        <IconTrophy size={48} className="w-100 text-primary" />
                    </Col>
                    <Col xs="7" lg="12" className="d-flex align-items-center">
                        <h3 className={`text-primary text-left text-lg-center m-0 w-100 ${styles.CampaignFlowHeading}`}>
                            Finale:
                            <br />
                            {shortenDate(phases.voteStartFinale, phases.voteEnd)}
                        </h3>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default CampaignFlow;
